import { observer } from "mobx-react-lite";
import React, { createContext, ReactNode, useContext } from "react";

import { TemplateFormat } from "../Playground/types";

export enum ContentNodeType {
  Snippet = "snippet",
  DatasetExamples = "datasetExamples",
  InputVariable = "inputVariable",
  Tag = "tag",
}

export interface EditorConfig {
  format?: TemplateFormat;
  snippetOverrides?: Record<string, string>;
  disableInteractive?: boolean;
  disabledNodes?: ContentNodeType[];
  inputVariables?: string[];
}

export const isNodeEnabled = (
  config: EditorConfig | undefined,
  nodeType: ContentNodeType,
): boolean => {
  if (!config?.disabledNodes || config.disabledNodes.length === 0) {
    return true;
  }
  return !config.disabledNodes.includes(nodeType);
};

const EditorConfigContext = createContext<EditorConfig | undefined>(undefined);

interface EditorConfigProviderProps {
  children: ReactNode;
  config?: EditorConfig;
}

export const EditorConfigProvider: React.FC<EditorConfigProviderProps> = observer(
  ({ children, config = {} }) => (
    <EditorConfigContext.Provider value={config}>{children}</EditorConfigContext.Provider>
  ),
);

export const useEditorConfig = () => {
  const context = useContext(EditorConfigContext);
  if (context === undefined) {
    return {};
  }
  return context;
};
